var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatterns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 335,
    viewBox: "0 0 404 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H4V4H0V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H24V4H20V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H44V4H40V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H64V4H60V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H84V4H80V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H104V4H100V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H124V4H120V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140 0H144V4H140V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160 0H164V4H160V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M180 0H184V4H180V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M200 0H204V4H200V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220 0H224V4H220V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240 0H244V4H240V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M260 0H264V4H260V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280 0H284V4H280V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0H304V4H300V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320 0H324V4H320V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340 0H344V4H340V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M360 0H364V4H360V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M380 0H384V4H380V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M400 0H404V4H400V0Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H4V24H0V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H24V24H20V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20H44V24H40V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20H64V24H60V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80 20H84V24H80V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100 20H104V24H100V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M120 20H124V24H120V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140 20H144V24H140V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160 20H164V24H160V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M180 20H184V24H180V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200 20H204V24H200V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M220 20H224V24H220V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M240 20H244V24H240V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M260 20H264V24H260V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M280 20H284V24H280V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300 20H304V24H300V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M320 20H324V24H320V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M340 20H344V24H340V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M360 20H364V24H360V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M380 20H384V24H380V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M400 20H404V24H400V20Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40H4V44H0V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40H24V44H20V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40H44V44H40V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40H64V44H60V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40H84V44H80V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M100 40H104V44H100V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M120 40H124V44H120V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140 40H144V44H140V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M160 40H164V44H160V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M180 40H184V44H180V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M200 40H204V44H200V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220 40H224V44H220V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M240 40H244V44H240V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M260 40H264V44H260V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M280 40H284V44H280V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M300 40H304V44H300V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M320 40H324V44H320V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M340 40H344V44H340V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M360 40H364V44H360V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M380 40H384V44H380V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M400 40H404V44H400V40Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60H4V64H0V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60H24V64H20V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40 60H44V64H40V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60H64V64H60V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60H84V64H80V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60H104V64H100V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M120 60H124V64H120V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M140 60H144V64H140V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M160 60H164V64H160V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M180 60H184V64H180V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200 60H204V64H200V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M220 60H224V64H220V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M240 60H244V64H240V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M260 60H264V64H260V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M280 60H284V64H280V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M300 60H304V64H300V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M320 60H324V64H320V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M340 60H344V64H340V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M360 60H364V64H360V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M380 60H384V64H380V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M400 60H404V64H400V60Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 80H4V84H0V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80H24V84H20V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80H44V84H40V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80H64V84H60V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M80 80H84V84H80V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M100 80H104V84H100V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M120 80H124V84H120V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M140 80H144V84H140V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M160 80H164V84H160V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M180 80H184V84H180V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M200 80H204V84H200V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M220 80H224V84H220V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M240 80H244V84H240V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M260 80H264V84H260V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M280 80H284V84H280V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M300 80H304V84H300V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M320 80H324V84H320V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M340 80H344V84H340V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M360 80H364V84H360V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M380 80H384V84H380V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M400 80H404V84H400V80Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100H4V104H0V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100H24V104H20V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100H44V104H40V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100H64V104H60V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M80 100H84V104H80V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100H104V104H100V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M120 100H124V104H120V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M140 100H144V104H140V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M160 100H164V104H160V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M180 100H184V104H180V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100H204V104H200V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M220 100H224V104H220V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M240 100H244V104H240V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M260 100H264V104H260V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M280 100H284V104H280V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M300 100H304V104H300V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M320 100H324V104H320V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M340 100H344V104H340V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M360 100H364V104H360V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M380 100H384V104H380V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M400 100H404V104H400V100Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 120H4V124H0V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M20 120H24V124H20V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120H44V124H40V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120H64V124H60V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120H84V124H80V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M100 120H104V124H100V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M120 120H124V124H120V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M140 120H144V124H140V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M160 120H164V124H160V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M180 120H184V124H180V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M200 120H204V124H200V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M220 120H224V124H220V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M240 120H244V124H240V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M260 120H264V124H260V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M280 120H284V124H280V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M300 120H304V124H300V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M320 120H324V124H320V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M340 120H344V124H340V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M360 120H364V124H360V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M380 120H384V124H380V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M400 120H404V124H400V120Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 140H4V144H0V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20 140H24V144H20V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M40 140H44V144H40V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M60 140H64V144H60V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M80 140H84V144H80V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M100 140H104V144H100V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M120 140H124V144H120V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M140 140H144V144H140V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M160 140H164V144H160V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M180 140H184V144H180V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M200 140H204V144H200V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M220 140H224V144H220V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M240 140H244V144H240V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M260 140H264V144H260V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M280 140H284V144H280V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M300 140H304V144H300V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M320 140H324V144H320V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M340 140H344V144H340V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M360 140H364V144H360V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M380 140H384V144H380V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M400 140H404V144H400V140Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 160H4V164H0V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M20 160H24V164H20V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M40 160H44V164H40V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M60 160H64V164H60V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M80 160H84V164H80V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M100 160H104V164H100V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M120 160H124V164H120V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M140 160H144V164H140V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M160 160H164V164H160V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M180 160H184V164H180V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M200 160H204V164H200V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M220 160H224V164H220V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M240 160H244V164H240V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M260 160H264V164H260V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M280 160H284V164H280V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M300 160H304V164H300V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M320 160H324V164H320V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M340 160H344V164H340V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M360 160H364V164H360V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M380 160H384V164H380V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M400 160H404V164H400V160Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 180H4V184H0V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M20 180H24V184H20V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M40 180H44V184H40V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M60 180H64V184H60V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M80 180H84V184H80V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M100 180H104V184H100V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180H124V184H120V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M140 180H144V184H140V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M160 180H164V184H160V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M180 180H184V184H180V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M200 180H204V184H200V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M220 180H224V184H220V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M240 180H244V184H240V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M260 180H264V184H260V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M280 180H284V184H280V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M300 180H304V184H300V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M320 180H324V184H320V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M340 180H344V184H340V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M360 180H364V184H360V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M380 180H384V184H380V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M400 180H404V184H400V180Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 200H4V204H0V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M20 200H24V204H20V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M40 200H44V204H40V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M60 200H64V204H60V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M80 200H84V204H80V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M100 200H104V204H100V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M120 200H124V204H120V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M140 200H144V204H140V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M160 200H164V204H160V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M180 200H184V204H180V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M200 200H204V204H200V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M220 200H224V204H220V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M240 200H244V204H240V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M260 200H264V204H260V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M280 200H284V204H280V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M300 200H304V204H300V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M320 200H324V204H320V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M340 200H344V204H340V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M360 200H364V204H360V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M380 200H384V204H380V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M400 200H404V204H400V200Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 220H4V224H0V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20 220H24V224H20V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M40 220H44V224H40V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M60 220H64V224H60V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M80 220H84V224H80V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M100 220H104V224H100V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M120 220H124V224H120V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M140 220H144V224H140V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M160 220H164V224H160V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M180 220H184V224H180V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M200 220H204V224H200V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M220 220H224V224H220V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M240 220H244V224H240V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M260 220H264V224H260V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M280 220H284V224H280V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M300 220H304V224H300V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M320 220H324V224H320V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M340 220H344V224H340V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M360 220H364V224H360V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M380 220H384V224H380V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M400 220H404V224H400V220Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 240H4V244H0V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M20 240H24V244H20V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M40 240H44V244H40V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M60 240H64V244H60V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M80 240H84V244H80V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M100 240H104V244H100V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M120 240H124V244H120V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M140 240H144V244H140V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M160 240H164V244H160V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M180 240H184V244H180V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M200 240H204V244H200V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M220 240H224V244H220V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M240 240H244V244H240V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M260 240H264V244H260V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M280 240H284V244H280V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M300 240H304V244H300V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M320 240H324V244H320V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M340 240H344V244H340V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M360 240H364V244H360V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M380 240H384V244H380V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M400 240H404V244H400V240Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 260H4V264H0V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M20 260H24V264H20V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M40 260H44V264H40V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M60 260H64V264H60V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M80 260H84V264H80V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M100 260H104V264H100V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M120 260H124V264H120V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M140 260H144V264H140V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M160 260H164V264H160V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M180 260H184V264H180V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M200 260H204V264H200V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M220 260H224V264H220V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M240 260H244V264H240V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M260 260H264V264H260V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M280 260H284V264H280V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M300 260H304V264H300V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M320 260H324V264H320V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M340 260H344V264H340V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M360 260H364V264H360V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M380 260H384V264H380V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M400 260H404V264H400V260Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 280H4V284H0V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M20 280H24V284H20V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M40 280H44V284H40V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M60 280H64V284H60V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M80 280H84V284H80V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M100 280H104V284H100V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M120 280H124V284H120V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M140 280H144V284H140V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M160 280H164V284H160V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M180 280H184V284H180V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M200 280H204V284H200V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M220 280H224V284H220V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M240 280H244V284H240V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M260 280H264V284H260V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M280 280H284V284H280V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M300 280H304V284H300V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M320 280H324V284H320V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M340 280H344V284H340V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M360 280H364V284H360V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M380 280H384V284H380V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M400 280H404V284H400V280Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 300H4V304H0V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M20 300H24V304H20V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M40 300H44V304H40V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M60 300H64V304H60V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M80 300H84V304H80V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M100 300H104V304H100V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M120 300H124V304H120V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M140 300H144V304H140V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M160 300H164V304H160V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M180 300H184V304H180V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M200 300H204V304H200V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M220 300H224V304H220V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M240 300H244V304H240V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M260 300H264V304H260V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M280 300H284V304H280V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M300 300H304V304H300V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M320 300H324V304H320V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M340 300H344V304H340V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M360 300H364V304H360V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M380 300H384V304H380V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M400 300H404V304H400V300Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 320H4V324H0V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M20 320H24V324H20V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M40 320H44V324H40V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M60 320H64V324H60V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M80 320H84V324H80V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M100 320H104V324H100V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M120 320H124V324H120V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M140 320H144V324H140V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M160 320H164V324H160V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M180 320H184V324H180V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M200 320H204V324H200V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M220 320H224V324H220V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M240 320H244V324H240V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M260 320H264V324H260V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M280 320H284V324H280V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M300 320H304V324H300V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M320 320H324V324H320V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M340 320H344V324H340V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M360 320H364V324H360V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M380 320H384V324H380V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M400 320H404V324H400V320Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 340H4V344H0V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M20 340H24V344H20V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M40 340H44V344H40V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M60 340H64V344H60V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M80 340H84V344H80V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M100 340H104V344H100V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M120 340H124V344H120V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M140 340H144V344H140V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M160 340H164V344H160V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M180 340H184V344H180V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M200 340H204V344H200V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M220 340H224V344H220V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M240 340H244V344H240V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M260 340H264V344H260V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M280 340H284V344H280V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M300 340H304V344H300V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M320 340H324V344H320V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M340 340H344V344H340V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M360 340H364V344H360V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M380 340H384V344H380V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M400 340H404V344H400V340Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 360H4V364H0V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M20 360H24V364H20V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M40 360H44V364H40V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M60 360H64V364H60V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M80 360H84V364H80V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M100 360H104V364H100V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M120 360H124V364H120V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M140 360H144V364H140V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M160 360H164V364H160V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M180 360H184V364H180V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M200 360H204V364H200V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M220 360H224V364H220V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M240 360H244V364H240V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M260 360H264V364H260V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M280 360H284V364H280V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M300 360H304V364H300V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M320 360H324V364H320V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M340 360H344V364H340V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M360 360H364V364H360V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M380 360H384V364H380V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M400 360H404V364H400V360Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 380H4V384H0V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M20 380H24V384H20V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M40 380H44V384H40V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M60 380H64V384H60V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M80 380H84V384H80V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M100 380H104V384H100V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M120 380H124V384H120V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M140 380H144V384H140V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M160 380H164V384H160V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M180 380H184V384H180V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M200 380H204V384H200V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M220 380H224V384H220V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M240 380H244V384H240V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M260 380H264V384H260V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M280 380H284V384H280V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M300 380H304V384H300V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M320 380H324V384H320V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M340 380H344V384H340V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M360 380H364V384H360V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M380 380H384V384H380V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M400 380H404V384H400V380Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 400H4V404H0V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M20 400H24V404H20V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M40 400H44V404H40V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 400H64V404H60V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M80 400H84V404H80V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M100 400H104V404H100V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M120 400H124V404H120V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M140 400H144V404H140V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M160 400H164V404H160V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M180 400H184V404H180V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M200 400H204V404H200V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M220 400H224V404H220V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M240 400H244V404H240V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M260 400H264V404H260V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M280 400H284V404H280V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M300 400H304V404H300V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M320 400H324V404H320V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M340 400H344V404H340V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M360 400H364V404H360V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M380 400H384V404H380V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M400 400H404V404H400V400Z",
    fill: "#021744",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatterns);
export default __webpack_public_path__ + "static/media/patterns.0fc6c03b96aab3948a5a0191b2a2f146.svg";
export { ForwardRef as ReactComponent };